import { useState } from 'react'
import { Card, CardHeader, CardBody, Button, Label, Input, FormFeedback, Alert, Spinner } from 'reactstrap'
import useForm from '../CustomHooks/FormHook'
import { RESET_SCHEMA_MUTATION } from '../../graphql'
import { handleGraphQLErrors } from '../../utils.js'
import { gql } from '@apollo/client'
import { FaArrowLeft } from 'react-icons/fa'

const RESET_SCHEMA = gql(RESET_SCHEMA_MUTATION)

export default function ResetSchema() {
  console.log('ResetSchema rendered')

  const { inputs, handleInputChange, resetInputs } = useForm({ schemaName: '' }, handleSubmit)
  const [schemaNameState, setSchemaNameState] = useState({ state: '', message: '' })
  const [spinner, setSpinner] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [schemaReset, setSchemaReset] = useState(false)

  function startOver() {
    resetInputs({ schemaName: '' })
    setSchemaReset(false)
  }

  async function handleSubmit() {
    console.log('ResetSchema.handleSubmit: ', inputs.schemaName)
    if (!inputs.schemaName) {
      setGraphQLErrors([])
      setSchemaNameState({ state: 'has-danger', message: 'Schema Name is required.' })
    } else {
      setSchemaNameState({ state: '', message: '' })
      setSpinner(true)
      try {
        const { data, errors } = await window.apolloClient.mutate({ mutation: RESET_SCHEMA, variables: { schemaName: inputs.schemaName } })
        if (data.resetSchema === 'SUCCESS!') {
          setGraphQLErrors([])
          setSchemaReset(true)
        } 
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setSpinner(false)
      }
    }
  }

  let button =  <Button color="danger" onClick={handleSubmit}>Reset Schema</Button>
  if (spinner) {
    button = <Button disabled color="danger"><Spinner size="sm" /> Resetting schema...</Button>
  }

  let cardBody = 
    <CardBody>
      <Alert color="danger" isOpen={graphQLErrors.length ? true : false}>{graphQLErrors.length ? graphQLErrors[0].message : ''}</Alert>
      <Label for="schemaName">Schema Name</Label>
      <Input
        id="schemaName"
        name="schemaName"
        invalid={schemaNameState.state === 'has-danger'}
        valid={schemaNameState.state === 'has-success'}
        onChange={handleInputChange}
        data-cy="schema-name"
      />
      <FormFeedback>{schemaNameState.message}</FormFeedback>
      <div style={{ paddingTop: '10px', textAlign: 'center' }}>
        {button}
      </div>
    </CardBody>

  if (schemaReset) {
    cardBody = 
      <CardBody>
        <Alert color="success">{`Schema ${inputs.schemaName.toUpperCase()} was reset successfully!`}</Alert>
        <div style={{ textAlign: 'center' }}>
          <Button style={{ float: 'left' }} onClick={startOver}><FaArrowLeft /> Start Over</Button>
        </div>
      </CardBody>
  }

  return (
    <Card style={{ maxWidth: '500px', marginTop: '20px' }}>
      <CardHeader style={{ fontWeight: 'bold' }}>Reset Schema</CardHeader>
      {cardBody}
    </Card>
  )
}
